import BatchesWithoutBarcode from './BatchesWithoutBarcode'

export default BatchesWithoutBarcode
